import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducers/authSlice";
import appReducer from "../reducers/appSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
  },
});
